const batteryRanges = [
    {
        min: 0,
        max: 10,
        icon: 'battery-red-low',
        showWarning: true,
    },
    {
        min: 11,
        max: 25,
        icon: 'battery-red-medium',
        showWarning: true,
    },
    {
        min: 26,
        max: 50,
        icon: 'battery-yellow-low',
        showWarning: false,
    },
    {
        min: 51,
        max: 74,
        icon: 'battery-yellow-medium',
        showWarning: false,
    },
    {
        min: 75,
        max: 99,
        icon: 'battery-green-low',
        showWarning: false,
    },
    {
        min: 100,
        max: 100,
        icon: 'battery-green-full',
        showWarning: false,
    },
]

const ANTENNA_QUALITIES = {
    UNKNOWN: 'Unknown',
    BAD: 'Bad',
    POOR: 'Poor',
    AVERAGE: 'Average',
    GOOD: 'Good',
    EXCELLENT: 'Excellent',
}

const findBatteryRange = (value) => {
    let range = null
    if (Number.isNaN(parseInt(value))) {
        return range
    }
    batteryRanges.forEach((r) => {
        if (r.min <= value && r.max >= value) {
            range = r
        }
    })
    return range
}

export { batteryRanges, ANTENNA_QUALITIES, findBatteryRange }
